<template>
  <transition name="component-fade">
    <button
      v-show="nextStep != ''"
      class="nav-arrow nav-arrow--right"
      @click.prevent="goToNextStep"
    >
      <svg width="32" height="32">
        <use xlink:href="#icon-arrow-right" />
      </svg>
    </button>
  </transition>
</template>

<script>
export default {
  props: {
    nextStep: {
      type: String,
      required: true
    }
  },
  methods: {
    goToNextStep() {
      this.$router.push({ name: this.nextStep });
    }
  }
};
</script>
